import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  width: 100%;
  background: #438eb8;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TextArea = styled.span`
  color: #fff;
  font-size: 24px;
  padding: 20px;
`;
